import { render, staticRenderFns } from "./ClassroomSelector.vue?vue&type=template&id=20df5900"
import script from "./ClassroomSelector.vue?vue&type=script&lang=js"
export * from "./ClassroomSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports